<template>
  <div class="currencyBar">
    <div :class="isSelected('pound')" @click="currencySelect('pound')">&pound;</div>
    <div :class="isSelected('dollar')" class="symbol" @click="currencySelect('dollar')">&dollar;</div>
    <div :class="isSelected('euro')" class="symbol" @click="currencySelect('euro')">&euro;</div>
  </div>
</template>

<style lang="scss" scoped>
.currencyBar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.symbol {
  font-size: 20px;
  font-weight:bold;
  border: 2px $white solid;
  border-radius: 30px;
  width: 50px;
  height: 25px;
  text-align: center;
  color: $white;
  margin: 0px 5px 0px 5px;
  padding-top:0px;

  &:hover {
    border: 2px $green1 solid;
  }
}

.active {
  @extend .symbol;
  color: $orange;
  background: $white;
  border:none;
  padding: 2px 2px 2px 2px;
  &:hover {
    border: none;
  }
}
</style>

<script>
export default {
    methods:{
        currencySelect(currency){
            this.$store.commit('setCurrency',{currency: currency});
        },
        isSelected(symbol){
            const currentlySelected = this.$store.getters.getCurrency;
            if (symbol == currentlySelected){
                return "active"
            } else {
                return "symbol"
            }
        }
    }
}
</script>